import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnafriqModule } from './onafriq.module';
import { AccordionComponent } from './custom-components/accordion/accordion.component';
import { CardComponent } from './custom-components/card/card.component';
import { StepperComponent } from './custom-components/stepper/stepper.component';
import { IncidentComponent } from './custom-components/incident/incident.component';
import { PapiCustomDropdownComponent } from './custom-components/papi-custom-dropdown/papi-custom-dropdown.component';
import { ClickOutsideDirective } from '../core/directives/click-outside.directive';
import { AlertComponent } from './custom-components/alert/alert.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TruncatePipe } from '../core/pipe/truncate.pipe';
import { TruncateTextDirective } from '../core/directives/truncate-text.directive';
import { CustomToggleComponent } from './custom-components/custom-toggle/custom-toggle.component';
import { TooManyRowsComponent } from './custom-components/too-many-rows/too-many-rows.component';
import { MultipleSearchComponent } from './custom-components/multiple-search/multiple-search.component';
import { FilterModalComponent } from '../modules/dashboard/home/home-transactions/filter-modal/filter-modal.component';
import { FixRadioNameDirective } from '../core/directives/fix-radio-button-name.directive';

@NgModule({
  declarations: [
    AccordionComponent,
    CardComponent,
    StepperComponent,
    IncidentComponent,
    PapiCustomDropdownComponent,
    ClickOutsideDirective,
    FixRadioNameDirective,
    FilterModalComponent,
    AlertComponent,
    TruncatePipe,
    TruncateTextDirective,
    CustomToggleComponent,
    TooManyRowsComponent,
    MultipleSearchComponent
  ],
  imports: [CommonModule, OnafriqModule, ReactiveFormsModule, FormsModule],
  exports: [
    OnafriqModule,
    AccordionComponent,
    CardComponent,
    StepperComponent,
    IncidentComponent,
    PapiCustomDropdownComponent,
    ReactiveFormsModule,
    FormsModule,
    ClickOutsideDirective,
    FixRadioNameDirective,
    AlertComponent,
    TruncatePipe,
    TruncateTextDirective,
    CustomToggleComponent,
    FilterModalComponent,
    TooManyRowsComponent,
    MultipleSearchComponent
  ],
})
export class SharedModule {}
